"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Application_1 = require("./forms/Application");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var getParameterByName_1 = require("./lib/functions/getParameterByName");
var SignaturesCertificate_1 = require("./forms/SignaturesCertificate");
var styles = __importStar(require("./forms/Application/Application.module.css"));
var App = (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.isLoading = false;
        props.model.dispatcher.addListener(function () {
            _this.forceUpdate();
        });
        return _this;
    }
    App.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isLoading = true;
                return [2];
            });
        });
    };
    App.prototype.render = function () {
        var mode = getParameterByName_1.getParameterByName("mode");
        var form_id = this.props.model.form_id;
        console.log("form_id= " + form_id);
        var model = this.props.model;
        var html = React.createElement(Application_1.Application, { model: model });
        switch (form_id) {
            case "application_admissions":
                html = React.createElement(Application_1.Application, { model: model });
                break;
            case "signature_certificate":
                html = (React.createElement(SignaturesCertificate_1.SignatureCertificate, { model: model, title: "Signature certificate", subtitle: "Admissions Application", signatureId: "signature" }));
                break;
            default:
                html = (React.createElement("div", null,
                    React.createElement(Application_1.Application, { model: model }),
                    !window.isPdf && (React.createElement("div", { className: "row " + styles.sectionTitle },
                        React.createElement("div", { className: "col-xs-12" },
                            React.createElement("button", { id: "submit_form_button", type: "button", className: "btn btn-primary", disabled: model.isLoading || !model.user }, model.isLoading ? "Loading..." : "Submit")))),
                    React.createElement("footer", { className: "gray-divider" })));
        }
        return React.createElement("div", { className: "content container" }, html);
    };
    __decorate([
        mobx_1.observable
    ], App.prototype, "isLoading", void 0);
    App = __decorate([
        mobx_react_1.observer
    ], App);
    return App;
}(react_1.Component));
exports.App = App;
//# sourceMappingURL=data:application/json;base64,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